import axios from 'axios';

export default class ServicioGrupoListadoDocumentacionService {

    getServicioGrupoListadoDocumentacion(info) {            
        const url = process.env.VUE_APP_APIURL + `/api/serviciogrupolistadodocumentacion`;    
        return axios.post(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }

  
    createServicioGrupoListadoDocumentacion(info){
        const url = process.env.VUE_APP_APIURL + `/api/serviciogrupolistadodocumentacionalta`;     
        return axios.post(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }

    deleteServicioGrupoListadoDocumentacion(info){
        const url = process.env.VUE_APP_APIURL + `/api/serviciogrupolistadodocumentacionbaja`;     
        return axios.post(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }

   

}